export default __webpack_public_path__ + "static/media/frontCover.8549e86b.txt";